import React, { useEffect, useState, useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { Spin } from '@1c/ui';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import LinkButton from 'src/components/LinkButton';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import routes from 'src/constants/routes';
import useApplicationAllowedBanks from 'src/dataHooks/useApplicationAllowedBanks';
import styles from './styles.module.scss';

const Banks: React.FC = () => {
  const navigate = useNavigate();
  const [isOtherBanksExpanded, setIsOtherBanksExpanded] = useState(false);
  const otherBanksReducedLength = 3;
  const { fetchAllowedBanks, isAllowedBanksLoading, allowedBanks } = useApplicationAllowedBanks();
  const partnerBanks = allowedBanks?.partnerBanks || [];
  const otherBanks = allowedBanks?.otherBanks || [];

  const handleClick = () => {
    navigate(routes.main);
  };
  
  useEffect(() => {
    fetchAllowedBanks();
  }, []);
  
  const handleExpandOtherBanks = () => {
    setIsOtherBanksExpanded(true);
  }
  
  const renderedPartnerBanks = useMemo(() => (
    <>
      <Text type="h3">Банки-партнеры Агента 1С:СБП</Text>
      <Text type="p" muted italic small>
        Если у вас ещё не заключен договор на СБП с банком, выберите банк из списка и отправьте заявку на заключение
        договора.
      </Text>
      {partnerBanks.length > 0 ? (
        <ul>
          {partnerBanks.map((bank: any) => (
            <li key={bank.name}>
              <Link to={generatePath(routes.bankApplication, { bankUeid: bank.ueid })}>
                {bank.name}
              </Link>
            </li>
          ))}
        </ul>
      ) : <Text type="p">Список банков пуст</Text>
      }
      <Text type="p">Список банков будет расширяться.</Text>
    </>
  ), [partnerBanks]);
  
  const renderedOtherBanks = useMemo(() => (otherBanks.length > 0 ? (
      <>
        <Text type="h3">Другие банки</Text>
        <Text type="p" muted italic small>
          Для заключения договора на СБП с банком из этого списка, нужно обратиться непосредственно в банк.
          Выполнение операций через СБП с помощью токенов, которые были получены в Агенте 1С:СБП, возможно
          только при наличии действующего{' '}
          <a href="https://portal.1c.ru/applications/1C-SBP#prices" target="_blank">платного тарифа</a>.
        </Text>
        <ul>
          {isOtherBanksExpanded ? otherBanks.map((bank: any) => (
            <li key={bank.name}>
              <Text type="span" small>{bank.name}</Text>
            </li>
          )) : (
            <>
              {otherBanks.slice(0, otherBanksReducedLength).map((bank: any) => (
                <li key={bank.name}>
                  <Text type="span" small>{bank.name}</Text>
                </li>
              ))}
              <LinkButton onClick={handleExpandOtherBanks} className={styles['expand-button']}>
                Посмотреть весь список...
              </LinkButton>
            </>
          )}
        </ul>
      </>
    ) : null
  ), [otherBanks, isOtherBanksExpanded]);

  return (
    <ContentLayout size="small">
      <Text type="h2" className={styles['title']}>Список банков</Text>
      {isAllowedBanksLoading
        ? <Spin size={60} className={styles['spin']}/>
        : (
          <>
            {renderedPartnerBanks}
            {renderedOtherBanks}
          </>
        )}
      <div className={styles['button-wrapper']}>
        <Button variant="outlined" onClick={handleClick}>
          На Главную
        </Button>
      </div>
    </ContentLayout>
  );
};

export default Banks;
